import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import QuotationForm from './quotationFrom'; // Corrected import
import { createQuotation } from '../../../services/api/quotation';
import { getAllEvent } from '../../../services/api/Event';

const CreateQuotationPage = () => {
	const navigate = useNavigate();
	const [eventTypes, setEventTypes] = useState([]);
	const [loading, setLoading] = useState(false);

	const handleCreateQuotation = async (quotation: any) => {
		try {
			setLoading(true);
			await createQuotation(quotation);
			navigate('/quotation');
		} catch (error) {
			console.error('Failed to create quotation:', error);
		} finally {
			setLoading(false);
		}
	};
	const loadEventTypes = useCallback(async () => {
		try {
			const response = await getAllEvent();
			setEventTypes(response.data.eventTypes);
		} catch (error) {
			console.error('Failed to load event types:', error);
		}
	}, []);

	useEffect(() => {
		// loadQuotations();
		loadEventTypes();
	}, [loadEventTypes]);

	return (
		<div>
			{/* <h1>Create New Quotation</h1> */}
			<QuotationForm
				onSubmit={handleCreateQuotation}
				initialData={null} // Pass null for new quotation
				eventTypes={eventTypes} // Ensure eventTypes is passed
				setSelectedQuotation={() => {}} // Provide a no-op function
				loader={loading} // Default loader state
				onClose={() => navigate('/quotation')}
				setEventTypes={setEventTypes}
				loadEventTypes={loadEventTypes}
			/>
		</div>
	);
};

export default CreateQuotationPage;
